import { Injectable } from '@angular/core';
import { ConfigurationInfo } from '../models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable()
export class ConfigurationService {

    getRandomSeed(): string {
        return (Math.random() * 10000000000).toFixed(0);
    }

    constructor(private http: HttpClient, ) {
        //
    }

    public GetConfiguration(): Observable<ConfigurationInfo> {

        return this.http.get<ConfigurationInfo>(environment.getWishListUrl + '?_=' + this.getRandomSeed());
    }

}



// WEBPACK FOOTER //
// ./src/app/services/configuration.service.ts